import type { Scenario } from '../types/quote';

// EXAMPLE data — every figure below is a static placeholder, not a calculation.

export const borrower = {
  name: 'Alex Morgan',
  firstName: 'Alex',
  preparedOn: 'October 15, 2026',
};

export const homeDetails = {
  purchasePrice: 450000,
  downPaymentPercent: '10%',
  downPaymentAmount: 45000,
  loanAmount: 405000,
  term: '30-year fixed',
};

export const scenarios: Scenario[] = [
  {
    id: 'fullDoc',
    program: 'Full Doc',
    rate: '6.500%',
    apr: '6.710%',
    payment: [
      { label: 'Principal & interest', amount: 2559.88, tone: 'navy' },
      { label: 'Property taxes', amount: 468.75, tone: 'flame' },
      { label: "Homeowner's insurance", amount: 145.0, tone: 'flameSoft' },
      { label: 'Mortgage insurance', amount: 168.75, tone: 'navySoft', note: 'If applicable' },
    ],
    paymentTotal: 3342.38,
    cash: [
      { label: 'Down payment', amount: 45000 },
      { label: 'Origination fee', amount: 4050 },
      { label: 'Underwriting & funding fees', amount: 1295 },
      { label: 'Title fees', amount: 2850 },
      { label: "Homeowner's insurance (prepaid)", amount: 1740 },
      { label: 'Less seller concessions', amount: 6000, isCredit: true },
    ],
    cashTotal: 48935,
  },
  {
    id: 'bankStatement',
    program: 'Bank Statement',
    rate: '7.375%',
    apr: '7.612%',
    payment: [
      { label: 'Principal & interest', amount: 2797.24, tone: 'navy' },
      { label: 'Property taxes', amount: 468.75, tone: 'flame' },
      { label: "Homeowner's insurance", amount: 145.0, tone: 'flameSoft' },
      { label: 'Mortgage insurance', amount: 202.5, tone: 'navySoft', note: 'If applicable' },
    ],
    paymentTotal: 3613.49,
    cash: [
      { label: 'Down payment', amount: 45000 },
      { label: 'Origination fee', amount: 6075 },
      { label: 'Underwriting & funding fees', amount: 1495 },
      { label: 'Title fees', amount: 2850 },
      { label: "Homeowner's insurance (prepaid)", amount: 1740 },
      { label: 'Less seller concessions', amount: 6000, isCredit: true },
    ],
    cashTotal: 51160,
  },
];

export const loanOfficer = {
  name: 'Jordan Avery',
  initials: 'JA',
  title: 'Senior Loan Officer',
  company: 'United Mortgage Lending',
  nmls: 'NMLS #000000',
  phone: '(555) 010-0199',
  phoneHref: 'tel:+15550100199',
  email: 'jordan.avery@example.com',
};
